<template>
    <span>
        {{ startDate }} ({{ startTime }})

        <span v-if="startDate != endDate">
            to {{ endDate }} ({{ endTime }})
        </span>
    </span>
</template>

<script>
    import { mapGetters } from 'vuex'
    
    export default {
        props: {
            reservation: Object
        },
        computed: {
            startDate: function() {
                return this.formatDate(this.reservation.event.start);
            },
            startTime: function() {
                return this.formatTime(this.reservation.event.start);
            },
            endDate: function() {
                return this.formatDate(this.reservation.event.end);
            },
            endTime: function() {
                return this.formatTime(this.reservation.event.end);
            },
        }
    }
</script>




// WEBPACK FOOTER //
// DateAndTime.vue?e6a00af6